class BlockEtapes {
  constructor() {
    this._init();
  }

  _init() {
    const questions = document.querySelectorAll('.etapes__item.openable');

    questions.forEach(function (question) {
      question.addEventListener(
        'click',
        function () {
          question.classList.toggle(
            'active'
          );
        },
        false
      );
    });
  }
}

export const blockEtapes = new BlockEtapes();
